export default __webpack_public_path__ + "static/media/hht1_ep12_timeline_q01_b.df4e884f.png";